import Vue from 'vue'
import Vuex from 'vuex'
import device from './modules/device'
import report from './modules/report'
import demos from './demos'
import createPersistedState from 'vuex-persistedstate'
import { reportLengths } from '@/lib/consts'
import { storageAvailable } from '@/lib/funcs'
import * as Cookies from 'js-cookie'

Vue.use( Vuex )

const debug = process.env.NODE_ENV !== 'production'

const STORE_KEY = 'adobe_mobile_maturity'
let persistedStore

if ( storageAvailable('localStorage') ) {
  persistedStore = createPersistedState({
    key: STORE_KEY
  })
} else if ( storageAvailable('sessionStorage') ) {
  persistedStore = createPersistedState( {
    key: STORE_KEY,
    storage: window.sessionStorage
  } )
} else {
  persistedStore = createPersistedState( {
    key: STORE_KEY,
    storage: {
      getItem: key => Cookies.get( key ),
      setItem: ( key, value ) => Cookies.set( key, value, { expires: 3, secure: true } ),
      removeItem: key => Cookies.remove( key )
    }
  } )
}

export default new Vuex.Store( {
  state: {
    navHeight: 45,
    isMobile: false,
    demoCapable: true,
    didViewHome: false,
    winH: window.innerHeight,
    winW: window.innerWidth,
    isSmall: true,
    preloaderOn: false,
    sideNavHeight: 238,
    sideNavActiveIdx: 0,
    sideNavOnWhite: false,
    deskCtrlsHeight: 31,
    deskCtrlsOnWhite: false
  },
  mutations: {
    setNavHeight ( { navHeight }, num ) {
      navHeight = num
    },
    setIsMobile ( state, bool ) {
      state.isMobile = bool
    },
    setDemoCapable ( state, bool ) {
      state.demoCapable = bool
    },
    setHomeViewed ( state, bool ) {
      state.didViewHome = bool
    },
    setWinH ( state, num ) {
      state.winH = num
    },
    setWinW ( state, num ) {
      state.winW = num
    },
    setIsSmall ( state, bool ) {
      state.isSmall = bool
    },
    setPreloader ( state, bool ) {
      state.preloaderOn = bool
    },
    setSideNavHeight ( { sideNavHeight }, num ) {
      sideNavHeight = num
    },
    setSideNavActiveIdx ( state, num ) {
      state.sideNavActiveIdx = num
    },
    setSideNavOnWhite (state, bool) {
      state.sideNavOnWhite = bool
    },
    setDeskCtrlsHeight ( { deskCtrlsHeight }, num ) {
      deskCtrlsHeight = num
    },
    setDeskCtrlsOnWhite (state, bool) {
      state.deskCtrlsOnWhite = bool
    }
  },
  actions: {
    setNavHeight ( { commit }, num ) {
      (typeof num === 'number')
        ? commit( 'setNavHeight', num )
        : console.error( `Value passed to setNavHeight must be of type Number! Type of ${num} is ${typeof num}.` )
    },
    setIsMobile ( { commit, dispatch }, bool ) {
      commit( 'setIsMobile', bool )
      if ( !bool ) dispatch( 'setReportLength', reportLengths.long )
    },
    setDemoCapable ( { commit }, bool ) {
      commit( 'setDemoCapable', bool )
    },
    setHomeViewed ( { commit } ) {
      commit( 'setHomeViewed', true )
    },
    setWinSize ( { commit, state } ) {
      commit( 'setWinW', window.innerWidth )
      commit( 'setIsSmall', ( window.innerWidth < 768 || state.device.formFactor === 'Smartphone' ) )
      if ( !state.isMobile ) commit( 'setWinH', window.innerHeight )
      window.Waypoint.refreshAll()
    },
    setPreloader ( { commit }, bool ) {
      commit( 'setPreloader', bool )
    },
    setSideNavHeight ( { commit }, num ) {
      (typeof num === 'number')
        ? commit( 'setSideNavHeight', num )
        : console.error( `Value passed to setSideNavHeight must be of type Number! Type of ${num} is ${typeof num}.` )
    },
    setSideNavActiveIdx ( { commit }, num ) {
      (typeof num === 'number')
        ? commit( 'setSideNavActiveIdx', num )
        : console.error( `Value passed to setSideNavActiveIdx must be of type Number! Type of ${num} is ${typeof num}.` )
    },
    setSideNavOnWhite ( { commit }, bool ) {
      commit( 'setSideNavOnWhite', bool )
    },
    setDeskCtrlsHeight ( { commit }, num ) {
      (typeof num === 'number')
        ? commit( 'setDeskCtrlsHeight', num )
        : console.error( `Value passed to setDeskCtrlsHeight must be of type Number! Type of ${num} is ${typeof num}.` )
    },
    setDeskCtrlsOnWhite ( { commit }, bool ) {
      commit( 'setDeskCtrlsOnWhite', bool )
    }
  },
  modules: {
    device,
    report,
    demos
  },
  plugins: [ persistedStore ],
  strict: debug
} )



// WEBPACK FOOTER //
// ./src/store/index.js